<template>
    <div class="stock-back-container">
        <div class="qubie">
            <h2 @click="handleQubie" style="">回收与挂售的区别 <van-icon name="question-o" /></h2>
        </div>
        <van-popup v-model:show="showQubie" position="center" :style="{ height: '60%' }" >
    <div >
        <van-image  fit="contain" :src="require('@/assets/qubie.png')" /> 
    </div>
  </van-popup>
      <van-card
        class="recovery-card"
        :border="false"
      >
        <template #title>
          <div class="card-title">
            <span class="main-title">皮皮售回收</span>
            <div class="character-group">
               <van-image width="120" height="120" fit="contain" :src="require('@/assets/logo.png')" /> 
            </div>
          </div>
        </template>
        <template #desc>
          <div class="feature-list">
            <p>平台回收，直接打款</p>
            <p>上号交易，截胡包赔</p>
          </div>
<div style="display: flex;justify-content: space-around;gap: 10px;">
              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/ptgj.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">平台估价</span>
              </div>
              
               <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/jsjg.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">接受价格</span>
              </div>

              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/zxkf.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">联系客服</span>
              </div>
              
              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/cgfh.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">完成回收</span>
              </div>

              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/ymsq.jpg" alt="">
                <span style="font-size: 14px;color: #666666">一秒收钱</span>
              </div>
            </div>
            <br>

           
        </template>
      
        <template #bottom>
          <van-button 
            block 
            type="primary" 
            color="#000000"
            class="estimate-btn"
            @click="goBack"
          >
            去回收
          </van-button>
        </template>
      </van-card>
  
      <van-card
        class="listing-card"
        :border="false"
      >
        <template #title>
          <div class="card-title">
            <span class="main-title">挂售</span>
            <span class="sub-title">(需平台会员，现在免费)</span>
          </div>
        </template>
        <template #desc>
          <div class="feature-list">
            <p>自己上传商品，买卖双方直接交易</p>
            <p>平台充当第三方中介</p>
          </div>
           <div style="display: flex;justify-content: space-around;gap: 10px;">
              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/sjpt.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">上架平台</span>
              </div>
              
               <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/zjdj.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">自己定价</span>
              </div>

              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/mjpx.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">买家拍下</span>
              </div>
              
              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/cgfh.jpg" alt="">
                <span  style="font-size: 14px;color: #666666">成功发货</span>
              </div>

              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 60px;align-items: center">
                <img width="30" height="30" src="../assets/zdsq.jpg" alt="">
                <span style="font-size: 14px;color: #666666">坐等收钱</span>
              </div>
            </div>
            <br>
        </template>
        <template #bottom>
          <van-button 
            block 
            type="primary" 
            color="#000000"
            class="estimate-btn"
            @click="goStock"
          >
            去挂售
          </van-button>
        </template>
      </van-card>
    </div>
  </template>
  
  <script>
import { showToast } from 'vant'

  export default {
    name: 'StockOrBack',
    data() {
      return {
        showQubie:false,
        userInfo:{}
      }
    },
    created() {
      this.userInfo = this.$store.state.user.userInfo
      console.log(123)
    },
    methods: {
      goBack() {
        if(!this.userInfo.username){
          this.$router.push('/profile')
          showToast('请先登录')
          return
        }
        // if(this.userInfo.verifyFlag!=1){
        //   this.$router.push('/userauth')
        //   showToast('请先完成实名认证')
        //   return
        // }
        this.$router.push('/back')
      },
      goStock() {
        if(!this.userInfo.username){
          this.$router.push('/profile')
          showToast('请先登录')
          return
        }
        // if(this.userInfo.verifyFlag!=1){
        //   this.$router.push('/userauth')
        //   showToast('请先完成实名认证')
        //   return
        // }
        if(this.userInfo.isVip!=0 ){
          this.$router.push('/registermerchant')
          showToast('请先完成商户注册')
          return
        }
        this.$router.push('/stock')
      },
      handleQubie(){
        this.showQubie = true;
      },
    }
  }
  </script>
  
  <style  scoped>
  .stock-back-container {
    padding: 16px;
    background: #fff !important;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}
  
    .van-card {
      background: #ffffff;
      border-radius: 8px;
      margin-bottom: 16px;
      padding: 16px;
      width: 100%;  
    }
    .van-card:last-child {
        margin-bottom: 0;
      }
    .card-title {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      position: relative;
      
    }
  
    .main-title {
        font-size: 26px;
        font-weight: bold;
        color: #000;
      }
  
      .sub-title {
        font-size: 14px;
        color: #666;
        margin-left: 8px;
      }

    .character-group {
      display: flex;
      align-items: center;
      margin-left: auto;
      position: absolute;
      top: -50px;
      right: 10px;
    }
  
    p {
        color: #666;
        font-size: 14px;
        line-height: 1.5;
        margin: 8px 0;
  
        &:first-child {
          margin-top: 0;
        }
  
        &:last-child {
          margin-bottom: 0;
        }
      }
  
    .estimate-btn {
      margin-top: 0px;
      height: 44px;
      font-size: 16px;
      border-radius: 4px;
    }
    .recovery-card{
        background-color: #f9f9f9;
        margin-bottom: 0px !important;
    }

    .listing-card{
        background-color: #f9f9f9;
    }

    .qubie{
        height:100px;
        font-size: 20px;
        padding-top: 20px;
        color: #666;
    }
  </style>